import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import VendorGrid from "../components/VendorGrid";
import useVendors from "../hooks/useVendors";
import usePageMeta from "../hooks/usePageMeta";
import { useFavorites } from "../context/FavoritesContext";
import { useLang } from "../i18n/LanguageContext";

export default function Saved() {
  const vendors = useVendors();
  const { favorites } = useFavorites();
  const { t } = useLang();
  usePageMeta(t("meta.saved"));

  const saved = vendors.filter((v) => favorites.includes(v.id));

  return (
    <>
      <Navbar />
      <Head>
        <h1>♥ {t("saved.title")}</h1>
      </Head>
      {saved.length === 0 ? (
        <Empty>
          <p>{t("saved.empty")}</p>
          <Link to="/">{t("saved.browse")}</Link>
        </Empty>
      ) : (
        <VendorGrid vendors={saved} showHeader={false} />
      )}
      <Footer />
    </>
  );
}

const Head = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: clamp(36px, 6vw, 60px) clamp(20px, 5vw, 40px) 0;
  h1 {
    font-family: ${({ theme }) => theme.font.display};
    font-weight: 500;
    font-size: clamp(30px, 5vw, 46px);
    color: ${({ theme }) => theme.colors.ink};
  }
`;

const Empty = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  padding: 50px clamp(20px, 5vw, 40px) 120px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  p { color: ${({ theme }) => theme.colors.inkSoft}; font-size: 16px; }
  a { color: ${({ theme }) => theme.colors.green}; font-weight: 500; }
`;
